<template>
  <div class="Product-list" ref="listView" @scroll.passive="isReachBottom">
    <list-item
      v-for="(item, index) in list"
      :key="index"
      :desc="item.desc"
      :title="item.title"
      :img="item.img"
      :infoId="item.infoId"
      :price="item.price"
      :defaultSelect="defaultSelect"
      :selected="isSelected(item)"
      @click.native="choose(item)"
      class="list-item"
    ></list-item>
  </div>
</template>

<script>
import ListItem from '../ListItem'
import { isScrollToBottom, debounce } from '../../../../lib/utils'

export default {
  name: 'checkProductList',
  props: ['list', 'curSelect', 'defaultSelect'],
  data() {
    return {}
  },
  methods: {
    isSelected(item) {
      return this.curSelect.indexOf(item.infoId) > -1
    },
    choose(item) {
      this.$emit('select', item.infoId)
    },
    isReachBottom() {
      const listView = this.$refs.listView
      if (isScrollToBottom(listView)) {
        this.$emit('to-bottom')
      }
    }
  },
  mounted() {
    // 滚动函数防抖
    this.isReachBottom = debounce(this.isReachBottom, 100, false)
  },
  components: {
    ListItem
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
